/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCHClosedIcon24Regular = forwardRef('ArrowCollapseCHClosedIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.058 13.68a2.375 2.375 0 0 0 0-3.36l-5.69-5.689A.875.875 0 1 0 3.132 5.87l5.69 5.689a.625.625 0 0 1 0 .884L3.13 18.13a.875.875 0 1 0 1.238 1.237l5.689-5.689Z" }),
        React.createElement("path", { d: "M13.942 13.68a2.375 2.375 0 0 1 0-3.36l5.69-5.689a.875.875 0 1 1 1.237 1.238l-5.69 5.689a.625.625 0 0 0 0 .884l5.69 5.689a.875.875 0 1 1-1.238 1.237l-5.689-5.689Z" })));
});
